/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2545
 */

var r = require(/* 864 */"../2541/864")
var i = require(/* 1179 */"./1179/index")
module.exports = function (e, t) {
  return r(e, i(e), t)
}
